import React from "react";

export default function DeleteRarity({ formData, onDiscard, handleSubmit }) {
  return (
    <div className="container form-group text-center text-secondary col-sm-8 pt-5">
      <h3 className="row justify-content-md-center">
        Are you sure you want to delete this record?
        <b>
          <u>{formData.rarity_id}</u>
        </b>
      </h3>

      <div className="mt-4">
        <button className="btn bg-orange form-btn" onClick={handleSubmit}>
          Yes
        </button>
        {/* &nbsp; */}
        <button className="btn btn-secondary form-btn mx-3" onClick={onDiscard}>
          No
        </button>
      </div>
    </div>
  );
}
